import type { OutroConteudoGateway } from '@/application/port/out/OutroConteudoGateway';
import type { ListOutrosConteudosParams, OutroConteudo, UpsertOutroConteudoCommand } from '@/domain/model/OutroConteudo';

export class ListOutrosConteudos {
  constructor(private readonly gateway: OutroConteudoGateway) {}
  execute(params: ListOutrosConteudosParams = {}): Promise<OutroConteudo[]> { return this.gateway.list(params); }
}
export class CreateOutroConteudo {
  constructor(private readonly gateway: OutroConteudoGateway) {}
  execute(cmd: UpsertOutroConteudoCommand): Promise<OutroConteudo> { return this.gateway.create(cmd); }
}
export class UpdateOutroConteudo {
  constructor(private readonly gateway: OutroConteudoGateway) {}
  execute(id: string, cmd: UpsertOutroConteudoCommand): Promise<OutroConteudo> { return this.gateway.update(id, cmd); }
}
export class ArquivarOutroConteudo {
  constructor(private readonly gateway: OutroConteudoGateway) {}
  execute(id: string): Promise<void> { return this.gateway.arquivar(id); }
}
